<template>
	<div class="news-summary">
		<div class="news-header horizontal-center">
			<common-avatar :width="30" :name="data.staff.name" :staffId="data.staff.id" :image="data.staff.avatar"></common-avatar>
			<span class="name">{{ data.staff.name }}</span>
			<div class="space"></div>
			<span class="created">{{ data.created }}</span>
		</div>

		<div @click="onClick">
			<div v-if="isCategoryShow" class="category mt-10" :style="{ 'background-color': data.category.color }"><span>{{ data.category.name }}</span></div>

			<div class="news-title sv-title">{{ data.title }}</div>
				
			<div class="news-body">
				<div class="mb-10" v-html="$utils.ellipsis(data.body, 30)"></div>
				<div class="news-preview">
					<preview v-if="data.thumbnail_image_url" :image="data.thumbnail_image_url" :maxH="140"></preview>
				</div>
			</div>
		</div>

		<div class="news-footer horizontal-center mt-20 mb-10" v-if="!data.is_draft" >
			<like :count="data.like_count" :isLiked="data.is_liked" @click="onLikeClick"></like>
			<div class="space"></div>
			<div @click="onClick">
				<span class="mr-10">コメント</span>
				<span>{{ data.comment_count }}</span>
			</div>
		</div>

		<hr class="mt-10 mb-10" v-if="data.is_editable && isEditShow"/>

		<div class="news-buttons horizontal-center" v-if="data.is_editable && isEditShow">
			<div class="action-button horizontal-center" @click="onEditClick">
				<img :src="require('@/assets/icons/edit.svg')">
				<span>編集</span>
			</div>

			<div class="action-button horizontal-center ml-25" @click="onDeleteClick">
				<img :src="require('@/assets/icons/delete.svg')">
				<span>削除</span>
			</div>
		</div>

		<img class="new-icon" src="@/assets/icons/news_new.png" v-if="data.is_new" />
	</div>
</template>

<script>
import CommonAvatar from '@/components/CommonAvatar'
import Preview from '@/components/Preview'
import Like from '@/components/Like'

export default {
	name: 'NewsSummary',
	components: {
		CommonAvatar,
		Preview,
		Like,
	},
	props: {
		data: {
			type: Object,
			default: null,
		},
		isCategoryShow: {
			type: Boolean,
			default: false,
		},
		isEditShow: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
	},
	methods: {
		onClick: function() {
			if (!this.data.is_draft) {
				this.$emit('click', this.data.id);
			}
		},
		onLikeClick: async function() {
			let ep = 'news-likes';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, { 'news_id': this.data.id }, true);
				this.$utils.log(res);

				this.data.like_count = res.data.like_count;
				this.data.is_liked = res.data.is_liked;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
			}
		},
		onEditClick: function() {
			this.$emit('edit-click', this.data.id);
		},
		onDeleteClick: function() {
			this.$emit('delete-click', this.data.id);
		},
	},
}
</script>

<style lang="scss">

</style>
